__turbopack_context__.v({
  "selections-wrap": "SelectionsSection-module-sass-module__MJIgEa__selections-wrap",
});
